import View from './PipelineHistory';
import enhancer from './PipelineHistory.enhancer';

const PipelineHistory = enhancer(View);

export default PipelineHistory;
